import React, { useEffect } from 'react';
import '../css/About.css';

const About = () => {
  /* 🎯  Track pointer and store % coords in CSS vars  */
  useEffect(() => {
    const section = document.getElementById('about');

    const handleMove = (e) => {
      if (!section) return;
      const px = e.clientX / window.innerWidth;   // 0 → 1
      const py = e.clientY / window.innerHeight;  // 0 → 1
      section.style.setProperty('--px', px);
      section.style.setProperty('--py', py);
    };

    window.addEventListener('pointermove', handleMove);
    return () => window.removeEventListener('pointermove', handleMove);
  }, []);

  return (
    <section className="about-section" id="about">
      {/* ✨ Starfield layers */}
      <div className="stars"></div>
      <div className="stars2"></div>
      <div className="stars3"></div>

      {/* 💎 Glass card */}
      <div className="about-card">
        <h2 className="about-title">About Me</h2>
        <p className="about-description">
          I’m Onur, a <span className="highlight">Full&nbsp;Stack&nbsp;Developer</span> with a passion for building
          <span className="highlight"> scalable</span> and <span className="highlight">secure</span> applications.
          My expertise spans <span className="highlight">Node.js, Flask, React.js</span>, and <span className="highlight">MongoDB</span>,
          delivering solutions that accelerate business growth and enhance user experiences.
        </p>

        <ul className="skills-list">
          <li><span className="skill-icon">⚙️</span> Node.js & Express</li>
          <li><span className="skill-icon">🔥</span> Flask & Python</li>
          <li><span className="skill-icon">⚛️</span> React.js</li>
          <li><span className="skill-icon">🗄️</span> MongoDB & SQL</li>
          <li><span className="skill-icon">🔒</span> JWT & Security</li>
          <li><span className="skill-icon">⚡</span> Performance Optimization</li>
        </ul>
      </div>
    </section>
  );
};

export default About;
